import { taskBoardSlice } from 'data/task-board/slice';
export * from './actions';
export const taskBoardReducer = taskBoardSlice.reducer;
